<template>
  <div class="cursorPointer-page">
    <!-- 头像信息 -->
    <div>
      <el-popover
        placement="bottom"
        trigger="hover"
        style="padding: 0"
        class="platformFlag"
        :popper-class="getPopoverClass"
      >
        <!-- <div slot="reference" class="displayStart">
        <img src="@/assets/new-image/header/topMember.svg" alt style="width: 26px;margin-right:4px"  />
        <encrypt :text="sellerPlatform.platformAccountInfo.userName + ''" :isNeed="false" decryptText=""></encrypt>
        <i style="position: relative; vertical-align: middle;margin-left: 4px;" class="el-icon-arrow-down"></i>
      </div> -->
        <template #reference>
          <div class="user-img-box">
            <img src="../../../assets/new-image/header/user.png" />
          </div>
        </template>

        <div>
          <div style="padding: 0 0 0 10px">
            <div class="information" style="margin-top: 6px; display: flex">
              员工姓名：<encrypt
                :text="sellerPlatform.platformAccountInfo.userName + ''"
                decryptText=""
              ></encrypt>
            </div>
            <div class="flex-spc-x information" style="width: 265px">
              <div>
                员工手机：<encrypt
                  :text="
                    sellerPlatform.platformAccountInfo.mistinessMobile + ''
                  "
                  :decryptText="sellerPlatform.platformAccountInfo.mobile"
                ></encrypt>
              </div>
              <y-button @click="changePhone()" type="blueText" width="76px"
                >修改</y-button
              >
            </div>
            <div class="information">
              员工性别：
              <span v-if="sellerPlatform.platformAccountInfo.sex == 1">女</span>
              <span v-else-if="sellerPlatform.platformAccountInfo.sex == 2"
                >未知</span
              >
              <span v-else>男</span>
            </div>
            <div class="information">
              所属部门：{{ sellerPlatform.platformAccountInfo.deptName }}
            </div>
            <div class="flex-spc-x information">
              <div>
                登录账号：{{ sellerPlatform.platformAccountInfo.loginAccount }}
              </div>
              <y-button @click="handleChangePwd()" type="blueText">修改密码</y-button>
            </div>
          </div>
          <div
            class="callkf1"
            @click="log_out"
            style="width: 100%; height: 32px; margin-top: 16px"
          >
            退出登录
          </div>
        </div>
      </el-popover>
    </div>

    <!-- 修改手机号弹窗 -->
    <y-dialog
      title="修改手机号"
      :visible.sync="phoneDialog"
      width="480px"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      sureText="保存"
      @close="closeDialog"
      @comfirm="savePhone"
    >
      <div class="export-dialog-wrapper new-input-box">
        <el-form ref="phoneForm" :model="phoneForm" label-width="84px">
          <el-form-item label="原手机号">
            {{ sellerPlatform.platformAccountInfo.mistinessMobile }}
          </el-form-item>
          <el-form-item label="新手机号" prop="mobile">
            <el-input
              v-model="phoneForm.phone"
              placeholder="请输入"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="vcode" style="margin-bottom: 0">
            <el-input
              maxlength="6"
              v-model="phoneForm.code"
              placeholder="请输入"
              style="width: 196px"
            >
              >
            </el-input>
            <y-button
              type="lightBlue"
              style="margin-left: 8px"
              @click="getPhoneCode"
              :disabled="phonecodeDisabled"
              :styleTextObj="{
                width: '114px',
                height: '33px',
                'line-height': '0px',
              }"
              >{{ phonecodeMsg }}</y-button
            >
          </el-form-item>
        </el-form>
      </div>
    </y-dialog>

    <!-- 修改密码弹窗 -->
    <changePwd
      v-if="showEditPwd"
      :showChangePwd="showEditPwd"
      :pwdForm="editForm"
      @close="handleEditPwdClose"
      @saveEditSave="handleEditPwdClose"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import encrypt from "./common/encryptEye.vue";
import changePwd from "./common/changePwd/index.vue";
import {
  getCheckCode,
  updatePlatformAccountMobile,
  logOut,
} from "@/api/header/cursorPointer";
export default {
  name: "cursorPointer",
  props: [],
  components: {
    encrypt,
    changePwd,
  },
  data() {
    return {
      // sellerPlatform: {
      //   platformAccountInfo: {
      //     userName: "员工姓名",
      //     mistinessMobile: "12345678911",
      //   },
      // }, //用户信息
      phoneDialog: false, //修改手机号弹窗
      phonecodeMsg: "发送验证码",
      phonedown: 60, // 更换手机验证倒计时秒数
      phonecodeDisabled: false, // 更换手机验证是否可点击
      phoneForm: {
        phone: "",
        code: "",
      },
      showEditPwd: false, //密码弹窗
    };
  },
  computed: {
    ...mapGetters(["scaleValue"]),
    getPopoverClass() {
      return this.scaleValue > 1? "cursorPointer-popper" : ""
    },
    sellerPlatform() {
      let nowObj = {
        ...this.$store.getters.sellerData,
      };
      // 用户信息包含platformAccountInfo
      console.log(nowObj.hasOwnProperty("platformAccountInfo"), nowObj.platformAccountInfo);
      if(nowObj.hasOwnProperty("platformAccountInfo")){
        let platformAccountInfo = nowObj.platformAccountInfo;
        nowObj.platformAccountInfo.userName = platformAccountInfo.userName || '';
        nowObj.platformAccountInfo.mistinessMobile = platformAccountInfo.mistinessMobile || '';
      }else {
        nowObj.platformAccountInfo = {
          userName: "",
          mistinessMobile: "",
        };
      }
      console.log('nowObj', nowObj);
      return nowObj;
    },
  },
  mounted: function () {},
  created: function () {
    // console.log("登录信息", this.$store.getters.sellerData);
    // if (this.$store.getters.sellerData) {
    //   this.sellerPlatform = this.$store.getters.sellerData;
    // }
  },
  watch: {
    sellerPlatform: {
      handler(newValue, oldValue) {
        // console.log("newValue", newValue);
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    //修改手机号 --- start
    closeDialog() {
      this.phoneForm = {
        phone: "",
        code: "",
      };
      this.phoneDialog = false;
      if (this.phonedown === 60) this.phonecodeMsg = "发送验证码";
    },
    savePhone() {
      if (!this.phoneForm.phone) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      } else if (this.isPhoneNum(this.phoneForm.phone) == false) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      }
      if (!this.phoneForm.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      let params = {
        mobile: this.phoneForm.phone,
        vcode: this.phoneForm.code,
      };
      updatePlatformAccountMobile(params)
        .then((res) => {
          if (res.code == 200) {
            this.phoneDialog = false;
            this.$message.success("修改成功");
            this.getSellerPlatform();
          } else {
            console.log(res);
            console.log("Error: " + res.code);
            this.$message.warning(res.message);
          }
        })
        .catch(() => {});
    },
    changePhone() {
      this.phoneForm = {
        phone: "",
        code: "",
      };
      this.phonecodeMsg = "发送验证码";
      clearInterval(this.codeTimer);
      this.phonecodeDisabled = false;
      this.phonedown = 60;
      this.phoneDialog = true;
    },
    getPhoneCode() {
      if (!this.phoneForm.phone) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      } else if (this.isPhoneNum(this.phoneForm.phone) == false) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      }
      let params = {
        mobile: this.phoneForm.phone,
        sendType: 10,
      };

      getCheckCode(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("已发送");
            this.codeTimer = window.setInterval(() => {
              this.phonedown--;
              this.phonecodeDisabled = true;
              this.phonecodeMsg = `已发送 ${this.phonedown}s`;
              if (this.phonedown == 0) {
                clearInterval(this.codeTimer);
                this.phonecodeMsg = "重新获取";
                this.phonecodeDisabled = false;
                this.phonedown = 60;
              }
            }, 1000);
          } else {
            console.log("Error: " + res.code);
            this.phonecodeDisabled = false;
            this.$message.info(res.message);
          }
        })
        .catch(() => {
          this.phonecodeDisabled = false;
        });
    },
    //修改手机号 --- end

    // 修改密码 ---start
    handleChangePwd() {
      this.editForm = {
        platformCompanyUserId:
          this.sellerPlatform.platformAccountInfo.platformCompanyUserId,
        oldPassword: "",
        confirmPassword: "",
      };
      this.showEditPwd = true;
    },
    handleEditPwdClose() {
      this.editForm = {
        platformCompanyUserId: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      };
      this.showEditPwd = false;
    },
    // 修改密码 ---end

    //退出登录
    log_out() {
      logOut().then((res) => {
        this.$message.success("退出登录成功");
        // this.$store.state.sellerData = null;
        this.$store.dispatch("updateUserInfo", {});
        sessionStorage.setItem("isLogin", false);
        if (window.location.href.indexOf("testhyt") > -1) {
          //测试环境
          location.href = "http://yunzhoutest.yucrm.cn/login"; //测试环境
        } else if (window.location.href.indexOf("local") > -1) {
          this.$router.push("/login");
        } else {
          //正式环境
          location.href = "https://yz.yqcrm.cn/login"; //正式环境
        }
      });
    },
  },
};
</script>

<style lang="scss">
.cursorPointer-popper{
  transform-origin: right top!important;
}
</style>

<style scoped lang="scss">
.displayStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.cursorPointer-page {
  // height: 100%;
  .user-img-box {
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.information {
  margin: 16px 0;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
}
.callkf1 {
  border-top: 1px solid #eeeeee;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  text-align: center;
  /* margin: 0 auto; */
  cursor: pointer;
  padding: 16px;
  margin-bottom: 6px;
}
</style>